"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatusEnum = void 0;
var TransactionStatusEnum;
(function (TransactionStatusEnum) {
    TransactionStatusEnum[TransactionStatusEnum["PENDING"] = 0] = "PENDING";
    TransactionStatusEnum[TransactionStatusEnum["COMPLETED"] = 1] = "COMPLETED";
    TransactionStatusEnum[TransactionStatusEnum["FAILED"] = 2] = "FAILED";
})(TransactionStatusEnum || (exports.TransactionStatusEnum = TransactionStatusEnum = {}));
